import {
	Component,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
} from "@angular/core"
import { exportParamsObj } from "@app/definitions/types"
import { DatePickerComponent } from "@app/utils/date-picker/date-picker.component"
import { Modalable } from "@app/Modalable"
import { dateDisplay } from "@app/helpers"
import { COMMON_IMPORTS } from "@app/common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { FormsModule } from "@angular/forms"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { CancelBtnComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-data-export",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		DatePickerComponent,
		FormsModule,
		GenButtonGroupComponent,
		CancelBtnComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./data-export.component.html",
})
export class DataExportComponent extends Modalable {
	exportParamsObj: exportParamsObj = new exportParamsObj() //the object that holds the field values (and is send to api)
	sourceDocTypeCheckboxes = { invoice: true, expense: false } //holds flags for which documents to export
	file_name: string = "" //the file name to save locally
	@ViewChild("toDate") toDate: DatePickerComponent //the toDate element (used for resetting it if dates are in opposite order)

	ngOnInit() {
		//when called to open set dates, doctype and local filename
		this.exportParamsObj.exp_start_date = this.store.getDateStr()
		this.exportParamsObj.exp_end_date = this.store.getDateStr(true)
		this.exportParamsObj.doc_type = "csv"
		this.updateName()
	}
	onDateChange() {
		this.store.dateFieldsInfluences(
			this.exportParamsObj,
			"exp_start_date",
			"exp_end_date",
			this.toDate
		)
	}

	updateName() {
		//update the local filename according to dates and doc types to export
		const start = dateDisplay(this.exportParamsObj.exp_start_date)
		const end = dateDisplay(this.exportParamsObj.exp_end_date)
		const invoices = this.sourceDocTypeCheckboxes.invoice
			? this.lang.getVal("invoices") + " "
			: ""
		const expenses = this.sourceDocTypeCheckboxes.expense
			? this.lang.getVal("expenses") + " "
			: ""
		this.file_name = `${invoices}${expenses}${start} - ${end}`
	}

	async dataExport() {
		//send a request to the api do download the info into a file and save it locally
		this.exportParamsObj.source_doc_type = "invoice" //source type defaults to invoice
		if (this.sourceDocTypeCheckboxes.expense) {
			//if expense is checked, either have source type be "expense" or BOTH (if invoice is also chekced)
			this.exportParamsObj.source_doc_type =
				(this.sourceDocTypeCheckboxes.invoice ? "invoice&" : "") + "expense"
		}

		this.store.downloadToastFunc(async () => {
			const res: any = await this.apiService.download(
				"export_to",
				this.exportParamsObj
			)
			let ext = this.exportParamsObj.doc_type //get the file extension
			let doctypeToExt = {
				"hashav-mov": "dat",
				"hashav-hesh": "xlsx",
				"hashav-xlsx": "xlsx",
				bkmv: "txt",
			} //extention to actual extention conversion array
			if (doctypeToExt[ext]) {
				//if the extention is in the array - change it to the REAL extension
				ext = doctypeToExt[ext]
			}
			let name = this.file_name || "report" //the file name to save as created (or default)
			switch (this.exportParamsObj.doc_type) {
				case "hashav-mov":
				case "hashav-xlsx":
					name = "movein"
					break
				case "hashav-hesh":
					name = "heshin"
					break
			}
			this.apiService.downloadFile(res, name + "." + ext) //download the file
		})
	}
}
